import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Box, Button, Flex } from '@chakra-ui/react'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { Formik } from 'formik'
import { useNavigate } from 'react-router-dom'
import IconButton from '../../components/IconButton/IconButton'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import { DiscountContext } from '../../utils/hooks/Context/DiscountContext'
import { useLoadingContext } from '../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../utils/hooks/Context/RequestStatusContext'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'
import useEmployeeFilter from '../../utils/hooks/useTableFilter/useEmployeeFilter'
import useTableFilterStatus from '../../utils/hooks/useTableFilter/useTableFilterStatus'
import RechargeForm from '../RechargeForm'
import { formContexts } from '../RechargeForm/FormFactory/FormFactory'
import useDiscount from './hooks/useDiscount'
import { colors } from '../../utils/theme/styles'
import ConfirmModal from '../../components/CustomConfirmations/ConfirmModal'
import DiscountConfirmation from '../../components/CustomConfirmations/DiscountConfirmation'
import { numberFormat } from '../../utils/formats/formats'

function Discount() {
  const navigate = useNavigate()
  const [notitfy, setNotify] = useState(false)
  const [costCenterAssign, setCostCenterAssign] = useState(null)
  const { texts } = useLabels()
  const { employeeStatus, handleStatusChange } = useTableFilterStatus()
  const { handleChange, searchValue } = useEmployeeFilter()
  const {
    employees,
    discountIsValid,
    sendDiscount,
    handleEmployeesChange,
    resetEmployees,
    applyFilters,
    employeesChanged,
    totalPages,
    page,
    handleChangePage,
    handleChangeFilter,
    discountData,
    employeesChangedReplace,
    resetAmmount,
    fillTotalBalance,
    fillAllTotalBalance,
  } = useDiscount({
    sEstado: employeeStatus ? [employeeStatus] : [''],
    sBusqueda: searchValue || '',
  })
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const [confirmed, setConfirmed] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [data, setData] = useState({})

  const onSelectCostCenter = (value) => {
    setCostCenterAssign(value)
  }
  const onToogleNotify = useCallback(() => {
    setNotify((prevState) => !prevState)
  }, [])
  const totalAmount = useMemo(() => {
    return employeesChanged.reduce((acc, el) => {
      const num = el.nMonto ? numberFormat(el.nMonto, 'number') : 0
      return acc + num
    }, 0)
  }, [employeesChanged])

  const totalAccounts = useMemo(
    () =>
      employeesChanged.reduce((acc, el) => {
        const numberAmmount = numberFormat(el.nMonto, 'number')
        return numberAmmount > 0 ? acc + 1 : acc
      }, 0),
    [employeesChanged],
  )

  const closeConfirm = () => {
    setShowConfirm(false)
  }

  const doneRefill = (code) => {
    if (code === 200) {
      navigate('/refills')
      handleClose()
    }
  }
  const handleOk = (response) => {
    resetEmployees(
      employees.map((element) => {
        const findEmployee = response.data.cDatosDescuento.cEmpleados.find(
          (item) => element.sEmpleado === item.sEmpleado,
        )
        if (findEmployee) {
          return {
            ...element,
            ...findEmployee,
            sSaldo: findEmployee.nSaldo,
            nMonto: '',
          }
        }
        return { ...element, nMonto: '' }
      }),
    )
    handleCLoseLoading()
    handleSetTitle(response?.data?.sMensaje, response.status)
    handleChangeBody(
      <Button variant="primary" onClick={() => doneRefill(response.status)}>
        {response.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
      </Button>,
    )
    handleOpen()
  }
  const handleError = (response) => {
    handleCLoseLoading()
    handleSetTitle(response?.data?.error, response.status)
    handleChangeBody(
      <Button variant="primary" onClick={() => doneRefill(response.status)}>
        Contactar a soporte ahora
      </Button>,
    )
    handleOpen()
  }

  const sendData = async (values) => {
    handleOpenLoading()

    setConfirmed(false)
    await sendDiscount({
      ...values,
      sCentroCosto: costCenterAssign,
      bNotificacion: notitfy,
    })
      .then((res) => {
        handleOk(res)
      })
      .catch((error) => {
        handleError(error.response)
      })

    // await handleChangePage(1)
  }

  const handleConfirm = () => {
    setConfirmed(true)
    closeConfirm()
  }
  const handleShowConfirm = () => {
    setShowConfirm(true)
  }

  useEffect(() => {
    if (confirmed) {
      sendData(data)
    }
  }, [confirmed, data])

  useEffect(() => {
    resetAmmount()
  }, [])

  const context = useMemo(
    () => ({
      employees,
      handleEmployeesChange,
      resetEmployees,
      totalPages,
      page,
      handleChangePage,
      applyFilters,
      fillTotalBalance,
      discountData,
      employeeStatus,
      handleStatusChange,
      handleChangeFilter,
      handleChange,
      searchValue,
      employeesChangedReplace,
      employeesChanged,
      fillAllTotalBalance,
    }),
    [
      employees,
      handleEmployeesChange,
      applyFilters,
      handleChangeFilter,
      resetEmployees,
      totalPages,
      page,
      handleChangePage,
      discountData,
      employeeStatus,
      handleStatusChange,
      fillTotalBalance,
      handleChange,
      searchValue,
      employeesChangedReplace,
      employeesChanged,
    ],
  )

  return (
    <>
      <ConfirmModal
        isOpen={showConfirm}
        onContinue={handleConfirm}
        title="Autorizar descuento"
        onClose={closeConfirm}
        textButton="Realizar Descuento"
      >
        <DiscountConfirmation
          ammount={`${totalAmount}`}
          accounts={totalAccounts}
          handleAssign={onSelectCostCenter}
          handleNotify={onToogleNotify}
          assign={costCenterAssign}
          notify={notitfy}
        />
      </ConfirmModal>
      <Formik
        initialValues={{
          sCentroCosto: null,
          sSucursal: null,
          cEmpleados: [],
        }}
        onSubmit={(values) => {
          handleShowConfirm()
          setData(values)
        }}
      >
        {({ handleSubmit }) => (
          <Flex direction="column">
            <Box>
              <UnderlineHeading
                variant="h5"
                text={texts.choose_discount_type}
              />
            </Box>
            <Box>
              <DiscountContext.Provider value={context}>
                <RechargeForm formType={formContexts.discount} />
              </DiscountContext.Provider>
            </Box>
            <Box maxW="20vw" h="6vh" mt="48px" mb="125px" minW="250px">
              <IconButton
                variant={!discountIsValid ? 'gray' : 'secondary'}
                color={!discountIsValid ? colors.gray[900] : 'FFFFFF'}
                onClick={discountIsValid ? handleSubmit : () => null}
                icon={faCheckCircle}
                text={texts.confirm_discount}
              />
            </Box>
          </Flex>
        )}
      </Formik>
    </>
  )
}

export default Discount
